import { render, staticRenderFns } from "./accionesContenido.vue?vue&type=template&id=4756821e&scoped=true&"
import script from "./accionesContenido.vue?vue&type=script&lang=js&"
export * from "./accionesContenido.vue?vue&type=script&lang=js&"
import style0 from "./accionesContenido.vue?vue&type=style&index=0&id=4756821e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4756821e",
  null
  
)

export default component.exports